import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Tooltip, Typography } from "@mui/material";
// yup
import { BtnCloseInModal} from 'components/Common/Button';
import { GridColumns } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import Zoom from '@mui/material/Zoom';


const ModalWorkflowHistory = (props) => {

    const {
        IsOpen,
        setIsOpen,
        sVOCFormID,
        sMaxWidth = "md",
    } = props;

    const [DataRowHistory, setDataRowHistory] = useState([] as any)

    useEffect(() => {
        if (IsOpen) {
            onLoadData()
        }
    }, [IsOpen])


    const onLoadData = () => {
        let data = {
            sVOCFormID: sVOCFormID,
        }

        AxiosGet(`Workflow/WorkflowHistory`, data, (res) => {
            ResultAPI(res, null, () => {
                setDataRowHistory(res.data || [])
            })
        })
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "dAction",
            headerName: "วันที่",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sAction",
            headerName: "สถานะ",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
        },
        {
            field: "sActionBy",
            headerName: "ผู้ดำเนินการ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            flex: 4,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                return (
                    <Tooltip title={item.value} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"}>{item.value} </Typography>
                    </Tooltip>
                );
            },
        },
    ];

    return (

        <>
            <Dialog
                open={IsOpen}
                onClose={() => { setIsOpen(false) }}
                fullWidth={true}
                maxWidth={sMaxWidth}
            >
                <DialogTitle>
                    <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Typography>Workflow History</Typography>
                            </Grid>
                            <Grid item>
                                <BtnCloseInModal txt={"ยกเลิก"} onClick={() => { setIsOpen(false) }} />
                            </Grid>
                        </Grid>
                    </DialogTitle>
                <hr style={{ width: '100%', margin: '0' }} />
                <DialogContent>
                        <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center">
                            <Grid item xs={12}>
                                <DataGridMuiClient
                                    isLoading={false}
                                    rows={DataRowHistory}
                                    HiddenToolHead={true}
                                    Columns={dataColumn}
                                    backgroundHeaderCustom={"#004290"}
                                    sxCustomHeader={{ color: '#ffffff' }}
                                />
                            </Grid>
                        </Grid>
                </DialogContent>
            </Dialog>
        </>

    )
}

export default ModalWorkflowHistory